import { ArrowRight } from 'lucide-react';
import React from 'react';
import { Article } from '../types';

interface ArticleCardProps {
  article: Article;
  onClick: () => void;
}

export const ArticleCard: React.FC<ArticleCardProps> = ({ article, onClick }) => (
  <article
    onClick={onClick}
    className="group cursor-pointer bg-white overflow-hidden shadow-md hover:shadow-2xl transition-all duration-300"
  >
    {article.featuredImage && (
      <div className="overflow-hidden mb-6">
        <img
          src={article.featuredImage}
          alt={article.title}
          className="w-full aspect-video object-cover transition-transform duration-700 group-hover:scale-110"
        />
      </div>
    )}
    <div className="space-y-4 p-6">
      {article.isFeatured && (
        <span className="inline-block text-xs font-black tracking-widest uppercase text-yellow-500 font-headline">
          SUOSITTELEMME
        </span>
      )}
      <h3 className="text-3xl font-display font-black text-gray-900 leading-tight group-hover:text-yellow-500 transition-colors uppercase tracking-tight">
        {article.title}
      </h3>
      <p className="text-gray-700 text-lg leading-relaxed font-body">{article.excerpt}</p>
      <div className="flex items-center justify-between pt-4">
        <span className="text-sm font-bold uppercase tracking-wider text-gray-500 font-body">
          {new Date(article.publishedDate).toLocaleDateString('fi-FI')}
        </span>
        <span className="text-yellow-500 font-black flex items-center gap-2 group-hover:gap-3 transition-all uppercase text-sm tracking-wider font-headline">
          LUE <ArrowRight size={18} strokeWidth={3} />
        </span>
      </div>
    </div>
  </article>
);